import { render } from "./GeeqButtonComponent.vue?vue&type=template&id=9aafbfe4&scoped=true"
import script from "./GeeqButtonComponent.vue?vue&type=script&lang=js"
export * from "./GeeqButtonComponent.vue?vue&type=script&lang=js"

import "./GeeqButtonComponent.vue?vue&type=style&index=0&id=9aafbfe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aafbfe4"]])

export default __exports__